<template>
  <mm-table
    :columns="tableColumns"
    :data-source="listData"
    :min-col-width="110"
  >
    <template
      slot="order_no"
      slot-scope="{ row }"
    >
      <a
        class="order-no-link"
        @click="handleViewOrderDetail(row.order_id)"
      >{{ row.order_no }}</a>
    </template>
    <template
      slot="product_names"
      slot-scope="{ value }"
    >
      <span>{{ renderProductNames(value) }}</span>
    </template>

    <template
      slot="amount"
      slot-scope="{ value }"
    >
      <span>￥{{ value || 0 }}</span>
    </template>

    <template
      slot="refund_count"
      slot-scope="{ value, row }"
    >
      <span :style="{ color: hasRedInvoice(row.invoice_list) ? '#f0150f' : 'inherit' }">
        ￥{{ value || 0 }}
      </span>
    </template>

    <template
      slot="invoice_type"
      slot-scope="{ row }"
    >
      <slot
        name="invoice_type"
        :row="row"
      >
        <invoice-list-field
          :invoice-list="row.invoice_list"
          field-key="invoice_type_str"
        />
      </slot>
    </template>

    <template
      slot="invoice_no"
      slot-scope="{ row }"
    >
      <invoice-list-field
        :invoice-list="row.invoice_list"
        field-key="number"
      />
    </template>

    <template
      slot="invoice_amount"
      slot-scope="{ row }"
    >
      <invoice-list-field
        :invoice-list="row.invoice_list"
        field-key="amount"
      />
    </template>

    <template
      slot="invoice_date"
      slot-scope="{ row }"
    >
      <invoice-list-field
        :invoice-list="row.invoice_list"
        field-key="open_invoice_time"
      />
    </template>

    <template
      slot="bill_type"
      slot-scope="{ row }"
    >
      <invoice-list-field
        :invoice-list="row.invoice_list"
        field-key="bill_type_str"
      />
    </template>

    <template
      slot="status"
      slot-scope="{ row }"
    >
      <invoice-list-field
        :invoice-list="row.invoice_list"
        field-key="status_str"
      />
    </template>

    <template
      slot="operation"
      slot-scope="{ row }"
    >
      <slot
        name="operation"
        :row="row"
      />
    </template>
  </mm-table>
</template>

<script>
import InvoiceListField from './InvoiceListField.vue'
import { INVOICE_LIST_COLUMNS } from '../constants'

export default {
  name: 'InvoiceListTable',
  components: {
    InvoiceListField
  },
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => INVOICE_LIST_COLUMNS
    }
  },
  computed: {
    tableColumns() {
      return this.columns.map(column => ({
        ...column,
        title: column.title
      }))
    }
  },
  methods: {
    renderProductNames(productNames) {
      if (!productNames || productNames.length === 0) return '-'
      return productNames.join('，')
    },

    hasRedInvoice(invoiceList) {
      if (!invoiceList || invoiceList.length === 0) return false
      return invoiceList.some(item => item.bill_type === '2')
    },

    handleViewOrderDetail(orderId) {
      this.$router.push(`/order/detail/${orderId}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.order-no-link {
  cursor: pointer;
}
</style>